import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para todos los años de la técnica?',
    a: 'Sí. Organizado de forma progresiva para 4°, 5° y 6° año con planificaciones diferenciadas por nivel de cursada.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Descargás los PDFs al instante. Podés imprimir, compartir por WhatsApp con tus alumnos o proyectar en clase.'
  }, {
    q: '¿Necesito saber programar para usarlo?',
    a: 'No. El material está diseñado para que puedas enseñar programación aunque no seas experto en código. Todo está explicado paso a paso.'
  }, {
    q: '¿Qué lo diferencia de lo que hay en internet?',
    a: 'El material online es genérico, está en inglés o es para ingeniería universitaria. Este Kit fue creado para el laboratorio de la escuela técnica argentina, con lógica pedagógica de nivel secundario técnico.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 7 días para probarlo en el aula. Devolución del 100% sin preguntas ni formularios.'
  }, {
    q: '¿Sirve si soy maestro de taller y no profesor de teoría?',
    a: 'Absolutamente. Las actividades y fichas prácticas son el recurso central del maestro de taller. Los profesores de teoría usan los tomos, los ejercicios y el banco de evaluaciones.'
  }, {
    q: '¿Los proyectos incluyen las soluciones o código fuente?',
    a: 'Sí, todos los proyectos, tanto del kit básico como del upsell, incluyen el código resuelto y comentado para que el docente tenga la referencia exacta al corregir.'
  }, {
    q: '¿Puedo editar las evaluaciones y planificaciones?',
    a: 'Sí, el Tomo 6 incluye enlaces a versiones editables (Word/Google Docs) de las planificaciones anuales y modelos de examen para que puedas adaptarlos al formato de tu escuela.'
  }, {
    q: '¿Hay que pagar alguna mensualidad o suscripción?',
    a: 'No. Es un pago único. Comprás el kit hoy y te queda para siempre, con acceso de por vida a los archivos.'
  }, {
    q: '¿Qué medios de pago aceptan?',
    a: 'Aceptamos Mercado Pago, todas las tarjetas de crédito y débito, y transferencias bancarias. El pago es 100% seguro y el acceso es automático tras la confirmación.'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-card" data-id="element-55">
      <div className="max-w-2xl mx-auto" data-id="element-56">
        <h2 className="text-xl md:text-3xl font-black text-center mb-5 text-white" data-id="element-57">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-2" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-dark rounded-lg border ${openIndex === index ? 'border-brand-accent' : 'border-white/5'} overflow-hidden transition-all duration-300`} data-id="element-59">
              <button className="w-full px-3 py-2.5 md:px-4 md:py-3 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-60">
                <span className={`font-bold text-xs md:text-sm pr-3 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-61">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-4 h-4 text-brand-accent shrink-0" data-id="element-62" /> : <ChevronDown className="w-4 h-4 text-gray-500 shrink-0" data-id="element-63" />}
              </button>

              <div className={`px-3 md:px-4 overflow-hidden transition-all duration-300 ease-in-out bg-[#111] ${openIndex === index ? 'max-h-96 py-2.5 opacity-100 border-t border-white/10' : 'max-h-0 opacity-0'}`} data-id="element-64">
                <p className="text-xs md:text-sm text-gray-300 leading-relaxed font-medium" data-id="element-65">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}